import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setLoader } from "./MasterSlice";
import * as API from "../../utils/api.service";
import { TOAST_SUCCESS } from "../../utils/common.service";

export const getEmployeeListApiCall = createAsyncThunk("employeeList", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: employeeList } = await API.getEmployeeListApi(submitData);
        dispatch(setLoader(false))
        return employeeList;
    } catch (error) {
        throw error;
    }
});

export const editEmployeeDataApiCall = createAsyncThunk("editEmployeeData", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: editEmployeeData, code, message } = await API.editEmployeeDetailsApi(submitData);
        if (code === '1') {
            TOAST_SUCCESS(message);
        }
        dispatch(setLoader(false))
        return { data: editEmployeeData, code, message };
    } catch (error) {
        throw error;
    }
});

const initialState = {
    employeeList: {
        data: [],
        error: null,
    },
    editEmployeeData: {
        data: null,
        code: '',
        message: '',
        error: null,
    },
};

const employeeSlice = createSlice({
    name: "EMPLOYEE",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getEmployeeListApiCall.fulfilled, (state, action) => {
                state.employeeList.data = action.payload;
            })
            .addCase(getEmployeeListApiCall.rejected, (state, action) => {
                state.employeeList.error = action.error.message;
            })
            .addCase(editEmployeeDataApiCall.fulfilled, (state, action) => {
                const { message, code, data } = action.payload;
                state.editEmployeeData.data = data;
                state.editEmployeeData.message = message;
                state.editEmployeeData.code = code;
            })
            .addCase(editEmployeeDataApiCall.rejected, (state, action) => {
                state.editEmployeeData.error = action.error.message;
            });
    },
});

export default employeeSlice.reducer;